howspace.workspace.duplicate = (() => {
    'use strict';

    const run = (options) => {
        const {
            btn,
            modal,
            modalOpener,
            workspaceId,
            dataPayload,
            redirectToWorkspace = true,
        } = options;

        real.button.loading(btn, modal);

        const logError = response => {
            if (howspace.workspace.create.hasDomainError(response)) {
                return false;
            }
            if (response.status === 401) {
                return false;
            }
            return true;
        };

        real.ajax.json(real.baseUri + '/api/workspace/' + workspaceId + '/duplicate', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: (response) => {
                if (redirectToWorkspace && response.login_link_url) {
                    window.location = response.login_link_url;
                } else {
                    howspace.components.modal.close(modal);
                    howspace.dispatchEvent(modalOpener, howspace.workspace.duplicate.WORKSPACE_DUPLICATED);
                }
            },
            logError: logError,
            showErrorNotification: logError,
            error: response => {
                real.button.reset(btn, modal);
                if (howspace.workspace.create.hasDomainError(response)) {
                    const domainInput = modal.find('.workspace-domain');
                    howspace.form.markInvalidField(domainInput);
                    requestAnimationFrame(() => {
                        real.input.focus(domainInput);
                    });
                }
                if (response.status === 401) {
                    real.ajax.loopErrors(response, (error) => {
                        const workspaceDomain = JSON.parse(error.message)?.workspace_domain;
                        const link = `<br><a class="go-to-workspace-btn" href="https://${workspaceDomain}/" target="_blank" rel="noreferrer noopener nofollow">${workspaceDomain}</a>`;
                        real.notification.show('<div>' + howspace.translate('my_workspace_login_needed', {'workspace_domain': link}) + '</div>', 'danger');
                        $('#real-notification-bar').one(real.notification.STARTING_TO_SHOW_NEW_CONTENT, () => {
                            $('#real-notification-bar .go-to-workspace-btn').on('click', () => {
                                real.notification.hide();
                            });
                        });
                    });
                }
            }
        });
    };

    const initModal = (modal, modalOpener, redirectToWorkspace = true) => {
        modal = $(modal);

        howspace.workspace.create.initWorkspaceInfoHandlers(modal);

        modal.on('change', '.duplicate-only-seen-users-checkbox', function() {
            const adminUsersCount = modal.find('.preview-content .admin-users-count');
            const contentUsersCount = modal.find('.preview-content .from-content-users-count');
            const allUsersCount = modal.find('.preview-content .all-users-count');

            if (this.checked) {
                adminUsersCount.html('(' + adminUsersCount.data('seen-users-count') + ')');
                contentUsersCount.html('(' + contentUsersCount.data('seen-users-count') + ')');
                allUsersCount.html('(' + allUsersCount.data('seen-users-count') + ')');
            } else {
                adminUsersCount.html('(' + adminUsersCount.data('users-count') + ')');
                contentUsersCount.html('(' + contentUsersCount.data('users-count') + ')');
                allUsersCount.html('(' + allUsersCount.data('users-count') + ')');
            }
        });

        const duplicateBtn = modal.find('.duplicate-btn');
        duplicateBtn.on('click', () => {
            const dataPayload = real.form.getDataPayload(modal.find('.modal-body'));
            dataPayload.workspace_domain = $.trim(modal.find('input.workspace-domain').val()) + modal.find('.workspace-root-domain').text();
            dataPayload.new_duplication = true;

            const options = {
                btn: duplicateBtn,
                modal: modal,
                modalOpener: modalOpener,
                workspaceId: modal.find('.workspace-select').val() || modal.data('workspace-id'),
                dataPayload: dataPayload,
                redirectToWorkspace: redirectToWorkspace,
            };
            howspace.workspace.duplicate.run(options);
        });
    };

    const initSelectWorkspaceToDuplicateModal = (modal) => {
        modal = $(modal);

        // Same reload approach as the template picker: the search input lives outside the lister, so the
        // lister's own automatic form-scraping (descendants only) never sees it. Rebuild the query, bake
        // it into the lister's data-uri, then reload.
        modal.find('.search-input').on(howspace.components.searchInput.SEARCH, e => {
            const lister = modal.find('.howspace-lister');
            const dataPayload = {search: e.detail.value || ''};

            const baseUri = lister.data('uri').split('?')[0];
            lister.dataAndAttr('uri', baseUri + '?' + $.param(dataPayload));
            howspace.components.lister.reload(lister);
        });

        // The picker's cards have no separate "duplicate" button, the whole card is the click target
        // (matching My Howspace's own duplicate picker). The card carries its own next-step URL since the
        // controller segment differs between apps (my-workspaces vs workspaces).
        modal.on('click', '.workspace-duplicate-picker-card', e => {
            if (e.target.closest('.howspace-menu') !== null) {
                return;
            }

            howspace.components.modal.show(e.currentTarget.dataset.duplicateModalUrl + '?from_picker=1', duplicateModal => {
                howspace.workspace.duplicate.initModal(duplicateModal, duplicateModal);
            });
        });

    };

    return {
        WORKSPACE_DUPLICATED: 'howspace-workspace-duplicated',
        initModal: initModal,
        initSelectWorkspaceToDuplicateModal: initSelectWorkspaceToDuplicateModal,
        run: run,
    };
})();
